import React, { useContext, useState, useEffect } from "react";
import { ListItemSecondaryAction, Grid } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import { gridSpacing } from "store/constant";
import TextFieldInput from "components/input/TextFieldInput";
import { DatoSolicitudCredito, Plazos } from "utils/types";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import Steeper from "components/Steps/Steeper";
import { stepsSolicitudCredito } from "utils/Constantes";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import InputFieldSelectSimple from "components/inputSelect/InputFieldSelectSimple";
import { codigoEmpresa } from "utils/Constantes";
import { codigoAgencia } from "utils/Constantes";
import { codigoEstadoOperacion } from "utils/Constantes";
import { fechaFormat } from "utils/utils";
import Table from "components/Tabla/Table";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
import FeatherIcon from "feather-icons-react";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import moment from "moment";
import {
  listaPlazosUtil,
  procesoOK,
  procesoWarning,
  procesoError,
  listaTipoCuota,
} from "utils/Constantes";
import { isObjEmpty } from "utils/utils";
import { isElementOfType } from "react-dom/test-utils";
import { usePersona } from "../../context/persona";
const AprobarNegar = () => {
  const { infoPersona, setInfoPersona } = usePersona()
  const navigate = useNavigate();
  // HOOKS DE ESTADO NOTIFICACIONES
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");

  // HOOKS COMUN
  const [activaSeccionConsulta, setActivaSeccionConsulta] = useState(false);
  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const [disabledSiguiente, setDisabledSiguiente] = useState(false);
  const [numeriIdentificacion, setNumeriIdentificacion] = useState("");
  const [datosSolicitudCredito, setDatosSolicitudCredito] = useState(
    DatoSolicitudCredito()
  );
  const [listGarantias, setListGarantias] = useState([]);
  const [objPeriodicidad, setObjPeriodicidad] = useState({});

  const [objProductoTasa, setObjProductoTasa] = useState({});

  const [objCuentasExternas, setObjCuentasExternas] = useState({});

  const [objTipoCuenta, setObjTipoCuenta] = useState({});

  const [objDestinoCredito, setObjDestinoCredito] = useState({});

  const [objActividadEconomica, setObjActividadEconomica] = useState({});

  const [objTipoAcreditacion, setObjTipoAcreditacion] = useState({});

  // const [listaTipoCuota, setListaTipoCuota] = useState([])

  const [objTipoCuota, setObjTipoCuota] = useState({});
  const [creditos, setCreditos] = useState([]);

  // CONTROL STATE
  const [existeSocio, setExisteSocio] = useState(false);
  const [solicitudCreditoOK, setSolicitudCreditoOK] = useState(false);

  // ACCESOS STEPS
  const [stepsActive, setStepsActive] = useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  // Para la fechas de pago
  const [objFechaPago] = useState(moment().add(30, "day"));

  // FUNCIONES
  useEffect(() => {
    init();
    // INVOCA SERVICIOS PARA SOLICITUD DE CREDITO
  }, []);
  // FUNCIONES NOTIFICACION
  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
  // FUNCIONES COMUN
  const init = () => {
    setActivaSeccionConsulta(true);
    setStepsActive(0);
    setInfoPersona({ codigo: "" });
  };
  const handleSearchSocio = () => {
    try {
      (async () => {
        Api(
          endpoints.verificaSolicitudCreditoIdentificacion +
          "/" +
          numeriIdentificacion,
          "GET",
          null
        )
          .then((response) => {
            if (response.length === 0) {
              setDisabledGuardar(false);
              setDisabledSiguiente(false);
              generarNotificacion(
                true,
                "No existe el socio de acuerdo al numero de identificacion ingresado",
                2
              );
              return;
            }
            setCreditos(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.message, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.message, 3);
    }
  };
  const verificaTipoCuenta = (nomenclaturaTipoCuota) => {
    listaTipoCuota.forEach((element) => {
      if (element.nomenclatura === nomenclaturaTipoCuota) {
        setObjTipoCuota(element);
      }
    });
  };

  const handleSearchGarantiaOperacionCrediticia = () => {
    try {
      (async () => {
        Api(
          endpoints.consultagarantesOperacionCrediticia +
          "/" +
          datosSolicitudCredito.codigo,
          "GET",
          null
        )
          .then((response) => {
            if (response.length <= 0) {
              setListGarantias(response);
            } else {
              setListGarantias(response);
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };

  const onChangeIdentificacion = (identificacion) => {
    if (identificacion === undefined) return;
    setNumeriIdentificacion(identificacion);
  };

  // CAMBIO DE STEEPER
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const nextStep = () => {
    setStepsActive((prevActiveStep) => prevActiveStep + 1);
    if (stepsActive === 1) handleSearchGarantiaOperacionCrediticia();
  };
  const nextAprobar = () => {
    setStepsActive(3);
  };

  const backStep = () => {
    init();
    setActivaSeccionConsulta(true);
    setExisteSocio(false);
    setDisabledGuardar(true);
    setDisabledSiguiente(true);
  };
  const handleReset = () => {
    let newSkipped = skipped;
    if (isStepSkipped(stepsActive)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(stepsActive);
    }

    setStepsActive((prevActiveStep) => prevActiveStep - 1);
    setSkipped(newSkipped);
  };

  const onRowSelect = (row) => {
    console.log(row);

    setDatosSolicitudCredito(row);
    if (row.existeSolicitudCredito === true) {
      setSolicitudCreditoOK(row.existeSolicitudCredito);
      setObjPeriodicidad(row.periocidadMs);
      console.log("Datos registrados en producto");
      console.log(row.productoTasaMs);
      setObjProductoTasa(row.productoTasaMs);
      setObjDestinoCredito(row.destinoOpeCreMs);
      setObjCuentasExternas(row.ifipExternaMs);
      setObjTipoCuenta(row.tipoCuentaExternaMs);
      setObjActividadEconomica(row.actividadEconomicaMs);
      setObjTipoAcreditacion(row.tipoAcreditacionMs);
      // Asigna tipo de cuota
      verificaTipoCuenta(row.tipoCuota);
      // Sube datos del cotexto
      setInfoPersona({ codigo: row.codigo });

      setDisabledGuardar(true);
      setDisabledSiguiente(false);
    } else {
      setSolicitudCreditoOK(false);
      setDisabledGuardar(false);
      setDisabledSiguiente(true);
    }
    nextStep();
  };

  const handleSave = (codigoEstadoOperacion) => {
    console.log("actualziar estado");
    console.log(codigoEstadoOperacion);
    // ARMA PARAMETROS PARA REGISTRO EN BASE DE DATOS
    const parametros = {
      codigo: datosSolicitudCredito.codigo,
      ingreMs: {
        codigo: datosSolicitudCredito.ingresoPersonaMs.codigoEntidad,
      },
      ingresoPersonaMs: {
        codigo: datosSolicitudCredito.ingresoPersonaMs.codigo,
      },
      estadoOpeCreMs: {
        codigo: codigoEstadoOperacion,
      },
      observaciones: datosSolicitudCredito.observaciones,
      codigoUsuarioRegistra: getCodigoUsuario()
    };

    (async () => {
      Api(endpoints.apruebaNiega, "POST", parametros)
        .then((response) => {
          // Retorno datos Operacion Crediticia
          if (response.estado > 0) {
            generarNotificacion(true, response.mensaje, 1);
          } else generarNotificacion(true, response.mensaje, 3);
        })
        .catch((error) => {
          generarNotificacion(true, error.mensaje, 3);
          return;
        });
    })();
  };

  const columns = [
    {
      title: "Identificacion",
      field: "ingresoPersonaMs.personaMs.numeroIdentificacion",
      editable: false,
    },
    {
      title: "Socio",
      field: "ingresoPersonaMs.personaMs.nombres",
      editable: false,
    },
    {
      title: "Crédito",
      field: "codigo",
      editable: false,
    },
    {
      title: "Monto",
      field: "valorSolicitado",
      editable: false,
    },
    {
      title: "Estado",
      field: "estadoOpeCreMs.descripcion",
      editable: false,
    },
  ];

  const columnsGarantes = [
    {
      field: "personaMs.numeroIdentificacion",
      title: "Identificación Garante",
      width: 90,
    },
    {
      field: "personaMs.nombres",
      title: "Nombres Garante",
      width: 90,
      editable: "never",
    },
    {
      field: "tipoGarante",
      title: "Tipo Garante",
      width: 150,
    },
    {
      field: "fechaRegistra",
      render: (rowData) => <p>{fechaFormat(rowData.fechaRegistra)}</p>,
      title: "Fecha creación",
      width: 150,
      editable: "never",
    },
  ];
  // VISTA
  const tamanoCaja = 6;
  const varianField = "outlined";
  return (
    <>

      <MainCard
        title="APROBAR / NEGAR SOLICITUD DE CRÉDITO"
        open={openNotificacion}
        mensajeVizualizar={visualizaMensaje}
        colorProceso={colorNotificacion}
        handleClose={() => cerrarNotificacion()}
        secondary={
          <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
        }
      >
        <Grid container xs={12} spacing={gridSpacing}>
          <Grid item xs={24}>
            {stepsActive === 0 && (
              <SubCard
                style={{ alignItems: "center" }}
                title="CONSULTA DATOS DE SOCIO"
              >
                <Grid container xs={12} spacing={1}>
                  <Grid item md={6}>
                    <TextFieldInput
                      label={"Cédula / nombres"}
                      md={tamanoCaja}
                      fullWidth
                      varianField={varianField}
                      value={numeriIdentificacion}
                      onChange={(e) => {
                        const valor = e.target.value;
                        if (valor.length === 11) {
                          return false;
                        }
                        onChangeIdentificacion(valor);
                      }}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <Table
                      id={"codigo"}
                      title="LISTADO DE CREDITOS / PERSONAS"
                      columns={columns}
                      data={creditos}
                      onRowClick={(evt, selectedRow) =>
                        onRowSelect(selectedRow)
                      }
                    ></Table>
                  </Grid>
                </Grid>
              </SubCard>
            )}
            {stepsActive === 1 && (
              <>
                <SubCard
                  style={{ alignItems: "center" }}
                  title="DATOS DEL SOCIO SOLICITANTE"
                >
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Identificación"}
                        sm={tamanoCaja}
                        fullWidth
                        variant={varianField}
                        value={numeriIdentificacion}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Nombres"}
                        md={tamanoCaja}
                        fullWidth
                        variant={varianField}
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .nombres
                        }
                      />
                    </Grid>
                  </Grid>
                </SubCard>

                <SubCard
                  style={{ alignItems: "center" }}
                  title="DETALLES DEL CRÉDITO SOLICITANTE"
                >
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Valor solicitado"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        value={datosSolicitudCredito.valorSolicitado}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idPlazos"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Plazo"}
                        value={datosSolicitudCredito.numeroCuota}
                      />
                    </Grid>
                  </Grid>
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idPeriodicidad"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Periodicidad"}
                        value={datosSolicitudCredito.periocidadMs.descripcion}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idProductoTasa"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Producto tasa"}
                        value={datosSolicitudCredito.productoTasaMs.descripcion}
                      />
                    </Grid>
                  </Grid>
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idDestinoOpeCredito"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Destino crédito"}
                        value={
                          datosSolicitudCredito.destinoOpeCreMs.descripcion
                        }
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Tasa interes"}
                        md={tamanoCaja}
                        fullWidth
                        varian={varianField}
                        value={datosSolicitudCredito.valorTasa}
                      />
                    </Grid>
                  </Grid>
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idTipoCuota"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Tipo cuota"}
                        value={
                          datosSolicitudCredito.tipoCuota === "F"
                            ? "Cuota Fija"
                            : "Cuota Varible"
                        }
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <DatePicker
                        label="Fecha de pago"
                        id="fechaPago"
                        value={datosSolicitudCredito.fechaPago?datosSolicitudCredito.fechaPago:objFechaPago}
                        inputFormat="DD/MM/YYYY"
                        renderInput={(params) => <TextField fullWidth {...params} style={{marginTop: "16px"}}/>}
                      />
                    </Grid>
                  </Grid>
                </SubCard>
                <SubCard
                  style={{ alignItems: "center" }}
                  title="DATOS DEL TITULAR DE LA CUENTA A LA QUE SE TRANSFIERE EL VALOR SOLICITADO"
                >
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Identificación"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        fullWidth
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .numeroIdentificacion
                        }
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Nombres"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .nombres
                        }
                      />
                    </Grid>

                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Número cuenta"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        value={datosSolicitudCredito.cuentaDestino}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        id={"idTipoAcreditacion"}
                        md={tamanoCaja}
                        fullWidth
                        variant={"outlined"}
                        label={"Tipo Acreditación"}
                        value={
                          datosSolicitudCredito.tipoAcreditacionMs.descripcion
                        }
                      />
                    </Grid>
                  </Grid>
                </SubCard>
              </>
            )}
            {stepsActive === 2 && (
              <SubCard
                style={{ alignItems: "center" }}
                title="  DATOS DE GARANTES"
              >
                <Grid container xs={12} spacing={gridSpacing}>
                  <Grid item xs={12}>
                    <div style={{ height: 600, width: "100%" }}>
                      <Table
                        title="Datos de garantes"
                        columns={columnsGarantes}
                        data={listGarantias}
                      ></Table>
                    </div>
                  </Grid>
                </Grid>
              </SubCard>
            )}
            {stepsActive === 3 && (
              <SubCard
                style={{ alignItems: "center" }}
                title=" APROBAR / NEGAR"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextFieldInput
                      label={"Observaciones"}
                      md={12}
                      fullWidth
                      size={90}
                      value={datosSolicitudCredito.observaciones}
                      onChange={(e) => {
                        const valor = e.target.value;

                        setDatosSolicitudCredito((prevState) => {
                          return { ...prevState, observaciones: valor };
                        });
                      }}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <Button
                      variant="contained"
                      style={{ margin: "0 8px" }}
                      color="success"
                      onClick={() => handleSave(2)}
                    >
                      Aprobar
                    </Button>
                    <Button
                      variant="contained"
                      style={{ margin: "0 8px" }}
                      color="warning"
                      onClick={() => handleSave(3)}
                    >
                      negar
                    </Button>
                  </Grid>
                </Grid>
              </SubCard>
            )}
          </Grid>
        </Grid>
        <br />
        <div className="steps-action">
          {stepsActive === 0 && (
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={true}
              onClick={handleSearchSocio}
            >
              <FeatherIcon icon="search" size={16} /> &nbsp; Consutar
            </Button>
          )}

          {stepsActive > 0 && stepsActive < 2 && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={nextStep}
                disabled={disabledSiguiente}
              >
                <FeatherIcon icon="chevrons-right" size={16} /> &nbsp; Siguiente
              </Button>
            </>
          )}
          {stepsActive > 0 && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={backStep}
                disabled={disabledSiguiente}
              >
                <FeatherIcon icon="x-circle" size={16} /> &nbsp; Cancelar
              </Button>
            </>
          )}

          {stepsActive > 0 && stepsActive < 3 && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={nextAprobar}
              >
                <FeatherIcon icon="refresh-ccw" size={16} /> &nbsp; Aprobar /
                negar
              </Button>
            </>
          )}
        </div>
      </MainCard>
    </>
  );
};
export default AprobarNegar;
